import React from 'react';

const Pyramid = ({ data, width, height }) => {
	// build legend based on given data of 100% of the height
	const legend = JSON.parse(JSON.stringify(data));
	let layers = JSON.parse(JSON.stringify(data));

	const cropSizePercent = 30;
	const totalHeight = height - 10;
	const totalWidth = width - 20;
	const actualHeight = totalHeight - totalHeight * cropSizePercent / 100;

	let totalValues = 0;
	layers.forEach(layer => totalValues += layer.value);
	layers.forEach(layer => {
		const layerValuePercent = layer.value / totalValues * 100;
		layer.height =  layerValuePercent * (100 - cropSizePercent) / 100;
	});

	layers.push({ color: 'orange', height: cropSizePercent });
	layers = layers.reverse();

	const topPoint = { x: width / 2, y: height };
	const baseLeft = { x: (width - totalWidth) / 2, y: 10 };
	const baseRight = { x: (width + totalWidth) / 2, y: 10 };

	const interpolate = (point1, point2, ratio) => ({
		x: point1.x + (point2.x - point1.x) * ratio,
		y: point1.y + (point2.y - point1.y) * ratio,
	});

	const calculateCentroid = (points) => {
		let xSum = 0, ySum = 0;
		points.forEach(point => {
			xSum += point.x;
			ySum += point.y;
		});
		return { x: xSum / points.length, y: ySum / points.length };
	};

	let currentHeight = 0;
	let previousBottomLeft = topPoint;
	let previousBottomRight = topPoint;
	const layerData = [];

	for (const layer of layers) {
		const layerHeight = (totalHeight * parseFloat(layer.height) / 100);
		currentHeight += layerHeight;

		const ratio = currentHeight / totalHeight;

		const bottomLeft = interpolate(topPoint, baseLeft, ratio);
		const bottomRight = interpolate(topPoint, baseRight, ratio);

		const d = `
		      M ${previousBottomLeft.x} ${previousBottomLeft.y}
		      L ${previousBottomRight.x} ${previousBottomRight.y}
		      L ${bottomRight.x} ${bottomRight.y}
		      L ${bottomLeft.x} ${bottomLeft.y}
		      Z
        `;

		const points = [
			previousBottomLeft,
			previousBottomRight,
			bottomLeft,
			bottomRight
		];

		previousBottomLeft = bottomLeft;
		previousBottomRight = bottomRight;

		const centroid = calculateCentroid(points);

		// Calculate font size based on layer height
		const fontSize = Math.min(12, layerHeight * 0.8);  // Adjust as needed

		layerData.push({
			color: layer.color,
			d,
			bottomLeft,  // add this property
			topPoint,    // and this one
			centroid,
			fontSize
		});
	}

	return (
		<div style={{display: 'flex', height: '100%'}}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${width} ${actualHeight}`} width={width} height={actualHeight}>
				{layerData.map((layer, index) => (
					index !== 0 ? (  // Skip rendering the first (bottom-most) layer
						<React.Fragment key={index}>
							<path
								d={layer.d}
								fill={layer.color}
							/>
							<text
								x={layer.centroid.x}
								y={layer.centroid.y}
								fill={layer.fontSize < 10 ? 'transparent' : 'white'}
								fontSize={layer.fontSize}
								textAnchor="middle"
								alignmentBaseline="middle"
							>
								{layers[index].label}
							</text>
						</React.Fragment>
					) : null
				))}
			</svg>
			<div>
				<div style={{display: 'flex', justifyContent: 'flex-end', fontSize: '12px', paddingTop: '50px'}}>Stage</div>
				{legend.map((layer, index) => (
					<div key={index} style={{display: 'flex', margin: '10px'}}>
						<div style={{backgroundColor: layer.color, width: '20px', height: '20px', marginRight: '10px'}} />
						<div style={{fontSize: '12px'}}>{layer.legendLabel}</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default Pyramid;
